import * as THREE from 'three';

// Classic flying saucer — disc body, glass dome, ring of warm under-lights,
// and a tractor beam that extends downward on demand.

export function createUfo() {
  const g = new THREE.Group();

  const bodyMat = new THREE.MeshStandardMaterial({
    color: 0xb4c0cc, roughness: 0.28, metalness: 0.88
  });
  const darkMat = new THREE.MeshStandardMaterial({
    color: 0x5a626e, roughness: 0.4, metalness: 0.78
  });

  // Top half of disc (gently tapered)
  const top = new THREE.Mesh(new THREE.CylinderGeometry(6.2, 5, 1.1, 32), bodyMat);
  g.add(top);

  // Bottom half (smaller, darker, recedes inward)
  const bottom = new THREE.Mesh(new THREE.CylinderGeometry(5, 2.4, 1.4, 32), darkMat);
  bottom.position.y = -1.1;
  g.add(bottom);

  // Rim torus — gives the silhouette
  const rim = new THREE.Mesh(new THREE.TorusGeometry(6.2, 0.55, 8, 36), bodyMat);
  rim.rotation.x = Math.PI / 2;
  rim.position.y = 0.1;
  g.add(rim);

  // Glass dome / cockpit
  const domeMat = new THREE.MeshStandardMaterial({
    color: 0x88c0f0, emissive: 0x4080c0, emissiveIntensity: 0.7,
    transparent: true, opacity: 0.6, roughness: 0.05, metalness: 0.4
  });
  const dome = new THREE.Mesh(
    new THREE.SphereGeometry(3.3, 24, 16, 0, Math.PI * 2, 0, Math.PI / 2),
    domeMat
  );
  dome.position.y = 0.6;
  g.add(dome);

  // Ring of 10 warm running lights along the underside rim
  const lightMat = new THREE.MeshBasicMaterial({ color: 0xffd060 });
  const lights = [];
  for (let i = 0; i < 10; i++) {
    const a = (i / 10) * Math.PI * 2;
    const light = new THREE.Mesh(new THREE.SphereGeometry(0.32, 10, 6), lightMat);
    light.position.set(Math.cos(a) * 5.4, -0.6, Math.sin(a) * 5.4);
    g.add(light);
    lights.push(light);
  }
  g.userData.lights = lights;

  // Tractor beam — open-ended cone-cylinder pointing DOWN.
  // Stored unit-length; scale.y becomes world length; position.y keeps top anchored at UFO bottom.
  const beamGeo = new THREE.CylinderGeometry(1.8, 9, 1, 24, 1, true);
  const beamMat = new THREE.MeshBasicMaterial({
    color: 0xffd060,
    transparent: true,
    opacity: 0.32,
    side: THREE.DoubleSide,
    depthWrite: false,
    fog: false
  });
  const beam = new THREE.Mesh(beamGeo, beamMat);
  beam.position.y = -1.5;
  beam.visible = false;
  g.add(beam);
  g.userData.beam = beam;

  // Inner brighter core for the beam (smaller radius)
  const beamCoreGeo = new THREE.CylinderGeometry(0.6, 4, 1, 16, 1, true);
  const beamCoreMat = new THREE.MeshBasicMaterial({
    color: 0xfff4d0,
    transparent: true,
    opacity: 0.55,
    side: THREE.DoubleSide,
    depthWrite: false,
    fog: false
  });
  const beamCore = new THREE.Mesh(beamCoreGeo, beamCoreMat);
  beamCore.position.y = -1.5;
  beamCore.visible = false;
  g.add(beamCore);
  g.userData.beamCore = beamCore;

  return g;
}

// length = world units the beam extends downward from the UFO underside
export function setBeamLength(ufo, length) {
  const b = ufo.userData.beam;
  const c = ufo.userData.beamCore;
  if (!b) return;
  if (length <= 0.01) {
    b.visible = false;
    if (c) c.visible = false;
    return;
  }
  b.visible = true;
  b.scale.y = length;
  b.position.y = -1.5 - length / 2;
  if (c) {
    c.visible = true;
    c.scale.y = length;
    c.position.y = -1.5 - length / 2;
  }
}
